<template>
  <div
    v-loading="loading"
    class="card no-margin-bottom"
  >
    <div class="card-body">
      <ui-quote>
        {{ $tc('Categories', 1) }}: <b>{{ category.name }}</b><br>
        <a
          href="#"
          @click.prevent="goBack('marketplacesCategories', { name: 'MarketplacesCategories' })"
        >
          <i class="fa fa-arrow-circle-left" /> {{ $t('Go back').toLowerCase() }}
        </a>
      </ui-quote>
      <ul class="nav nav-tabs">
        <li class="nav-item">
          <router-link
            :to="{ name: 'MarketplacesCategory' }"
            class="nav-link"
            replace
            exact
            @updated="load"
          >
            {{ $t('Main') }}
          </router-link>
        </li>
        <li class="nav-item">
          <router-link
            :to="{ name: 'MarketplacesCategoryTemplates' }"
            class="nav-link"
            replace
            exact
            @updated="load"
          >
            {{ $tc('Templates', 2) }}
          </router-link>
        </li>
      </ul>

      <div class="tab-content">
        <div class="tab-pane fade show active">
          <router-view @updated="load" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MarketplacesCategoriesService from '../services/MarketplacesCategoriesService';

export default {
  name: 'AppContainerMarketplacesCategory',
  data() {
    return {
      category: {},
      loading: false,
    };
  },
  computed: {
    /**
       * Returns Marketplace ID value from route.
       * @returns {number} Marketplace ID from route
       */
    categoryId() {
      return parseInt(this.$route.params.categoryId, 10);
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      this.loading = true;
      MarketplacesCategoriesService.findById(this.categoryId).then(category => {
        this.category = category;
        this.loading = false;
      }).catch(() => {
        this.$errors_go404();
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  .tab-pane {
    min-height: 60vh;
  }
</style>
